import Payer from "@/models/payer";
import User from "@/models/user";
import Merchant from "@/models/merchant";
import Invoice from "@/models/invoice";

export default {
  tokenization: {},
  transactionId: "",
  jwt: "",
  jwtTimestamp: null,
  checkoutStep: 1,

  //show login after fetching terms
  showLoginPanel: false,

  payment: {
    transactionResult: {
      TransactionId: "",
      IsSuccess: null,
      ErrorDetails: [],
      AccountMerchantLogId: "",
    },
    downloadInvoiceUrl: "",
    downloadSurchargeInvoiceUrl: "",
    message: "",
    // invoice has been paid yet.
    paymentStatus: false,
    paymentErrorMessage: "",
  },

  user: new User(),
  payer: new Payer(),

  isBillingDetailsUpdated: false,
  isRegisteringNewPayer: false,
  //if user registered, this url will be used to setup a password
  createPasswordUrl: "",

  merchant: new Merchant(),
  invoice: new Invoice(),

  //user has to select (click) on one of the payment methods to select it.
  selectedPaymentMethodIndex: null,

  //user sets this on how much he wants to pay - default is the value of invoice.amountDue
  payingToday: 0,
  surcharge: 0,

  //date of scheduled payment
  scheduledPaymentDate: "",

  termsAndConditions: {
    isSignatureRequired: false,
    signature: "",
    acceptedBy: "",
    acceptedByPosition: "",
    terms: [],
  },
  isVirtualTerminal: false,
  paymentInProgress: false,

  extraDataLoadingError: false,
  loadingInvoiceDetails: false,
  loadingTerms: false,
  loadingUserDetails: false,
  loadingPaymentMethods: false,

  onboardingToken: null,
  onboardingTermsId: null,
  partnerPortalUrl: null,
  isAutoPaymentTermsAssignedToOtherPayer: false,
  isOnboardingExpired: false,
  isUserActivated: false,
  isLoadingOnboardingData: false,
  isLoadingOnboardingDataError: false,

  connectWiseSell: {},

  //handles the alert details on each card
  alertGroups: {
    userDetails: [],
    billingDetails: [],
    paymentDetails: [],
    paymentReview: [],
    invoiceSearch: [],
  },

  thirdPartyIntegration: {},
  redirectInProgress: false,
  allowPartPayment: false,
  isNewPrepaymentFlowEnabled: false,
  isGuestBankPaymentAccepted: false,
  isGuestCreditCardPaymentAccepted: false,
  isBaseCurrency: null,

  userDetailsStep: {},
  requestAuthResponseBodyForTermsAcceptance: {},

  // Zero quote flow for sign-up
  avsBillingDetailsForZeroQuoteFlow: {},

  merchantPayerCompanies: [],
  isMerchantPayerCompaniesApiLoading: false,
  isPaymentDetailsInEdit: false,
  isPaymentEndpointFailed: false,
  accountId: 0,
  accountName: "",

  // States for all Step cards
  stepCardStates: {
    userDetails: {
      step: 1,
      isDisplayed: true,
    },
    billingDetails: {
      step: 2,
      isDisplayed: false,
    },
    payerDetails: {
      step: 3,
      isDisplayed: false,
    },
    paymentReview: {
      step: 4,
      isDisplayed: false,
    },
  },
};
